
import React from 'react';
import { motion } from 'framer-motion';

const Vision: React.FC = () => {
  const BUSINESS_DESIGN_IMAGE_URL = "https://lh3.googleusercontent.com/d/1F3wmBZNuAIjlBMjdJOXws4FK-ViKoyzN";
  const QUANTITATIVE_EVAL_IMAGE_URL = "https://lh3.googleusercontent.com/d/1quCc35BV7deWL00LgM_eD9HZPxxRczJ8";

  return (
    <section id="vision" className="py-24 px-6 bg-zinc-950/50">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-[#FFC222] font-bold mb-4">VISION</p>
          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight">
            사회적 가치와<br />
            비즈니스 수익의 결합
          </h2>
          <div className="space-y-6 text-zinc-400 leading-relaxed text-lg">
            <p className="text-white font-bold text-2xl italic mb-4">
              "평범한 우리가 만드는 비범한 임팩트"
            </p>
            <p>
              "특별한 사람만 세상을 바꾸는 것이 아닙니다." 인액터스에는 '네 옆의 평범한 찌질이가 세상을 바꾼다'는 믿음이 있습니다. 창업 경험이 없어도, 거창한 기술이 없어도 괜찮습니다.
            </p>
            <p>
              우리 주변의 문제를 외면하지 않고, 해결하고자 하는 의지만 있다면 누구나 ENACTUS YM의 주인공이 될 수 있습니다. ENACTUS YM은 지극히 평범한 대학생들이 모여 치열하게 시장을 분석하고, 비즈니스 모델을 설계하며, 실제 수익을 창출하는 '실전'을 경험합니다.
            </p>
            <p>
              이 과정을 통해 당신은 세상을 바꿀 임팩트를 가진 기업가로 성장하게 될 것입니다.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-2 gap-4"
        >
          <div className="bg-zinc-900 p-8 rounded-3xl aspect-square flex flex-col justify-between hover:bg-[#FFC222] hover:text-black transition-all group">
            <span className="text-4xl font-black opacity-20">01</span>
            <p className="font-bold text-xl">문제 정의 역량</p>
          </div>
          
          {/* Card 02 with Background Image */}
          <div className="relative overflow-hidden bg-zinc-900 p-8 rounded-3xl aspect-square flex flex-col justify-between mt-8 hover:scale-[1.02] transition-all group">
            <img 
              src={BUSINESS_DESIGN_IMAGE_URL} 
              alt="Business Design" 
              className="absolute inset-0 w-full h-full object-cover opacity-30 grayscale group-hover:grayscale-0 group-hover:opacity-50 transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/20 group-hover:from-black/40 transition-colors"></div>
            
            <span className="relative z-10 text-4xl font-black opacity-40 group-hover:opacity-100 text-white transition-opacity">02</span>
            <p className="relative z-10 font-bold text-xl text-white">비즈니스 설계</p>
          </div>

          {/* Card 03 with Background Image */}
          <div className="relative overflow-hidden bg-zinc-900 p-8 rounded-3xl aspect-square flex flex-col justify-between -mt-8 hover:scale-[1.02] transition-all group">
            <img 
              src={QUANTITATIVE_EVAL_IMAGE_URL} 
              alt="Quantitative Evaluation" 
              className="absolute inset-0 w-full h-full object-cover opacity-30 grayscale group-hover:grayscale-0 group-hover:opacity-50 transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/20 group-hover:from-black/40 transition-colors"></div>
            
            <span className="relative z-10 text-4xl font-black opacity-40 group-hover:opacity-100 text-white transition-opacity">03</span>
            <p className="relative z-10 font-bold text-xl text-white">정량적 평가</p>
          </div>

          <div className="bg-zinc-900 p-8 rounded-3xl aspect-square flex flex-col justify-between hover:bg-[#FFC222] hover:text-black transition-all group">
            <span className="text-4xl font-black opacity-20">04</span>
            <p className="font-bold text-xl">실질적 임팩트</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Vision;
